import { axios } from '@/utils/request'

const api = {
  orderList: '/badminapi/order/orderlist',
  orderDetail: '/badminapi/order/orderdetail',
  fenxiaoorderDetail: '/badminapi/order/fenxiaoorderdetail',

  goodsOptions: '/badminapi/order/goodsOptions',
  serviceApplyDo: '/badminapi/order/serviceApplyDo',
  orderSend: '/badminapi/order/orderSend',
  orderReceived: '/badminapi/order/orderReceived',
  expressCompanyOptions: '/badminapi/order/expressCompanyOptions',
  expressEdit: '/badminapi/order/expressEdit',
  priceFix: '/badminapi/order/priceFix',
  goodsRefund: '/badminapi/order/goodsRefund',
  orderRecover: '/badminapi/order/orderRecover',
  businessNoteEdit: '/badminapi/order/businessNoteEdit',
  adminNoteEdit: '/badminapi/order/adminNoteEdit',
  setOrderStar: '/badminapi/order/setOrderStar',
  expressImport: '/badminapi/order/expressImport',
  orderClose: '/badminapi/order/orderClose',
  orderCancel: '/badminapi/order/orderCancel',
  setAllStar: '/badminapi/order/setAllStar',
  tuanComplete: '/badminapi/order/tuanComplete',
  getOrderDownloadUrl: '/badminapi/order/getOrderDownloadUrl',
  fenxiaoOrderGoodsDownload: '/badminapi/order/getFenxiaoOrderDownloadUrl',

  businessOptions: '/badminapi/order/businessOptions',
  fenxiaoOrderList: '/badminapi/order/fenxiaoOrderList',
  fenxiaoGoodsOptions:'/badminapi/order/fenxiaoGoodsOptions',

  expressTrace:'/api/order/expressTrace',

}

export default api
export function getOrderList(parameter) {
  return axios({
    url: api.orderList,
    method: 'get',
    params: parameter
  })
}
export function getOrderDetail(parameter) {
  return axios({
    url: api.orderDetail,
    method: 'get',
    params: parameter
  })
}
export function getFenxiaoOrderDetail(parameter) {
  return axios({
    url: api.fenxiaoorderDetail,
    method: 'get',
    params: parameter
  })
}


export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}

export function getFenxiaoGoodsOptions(parameter) {
  return axios({
    url: api.fenxiaoGoodsOptions,
    method: 'get',
    params: parameter
  })
}
export function expressCompanyOptions(parameter) {
  return axios({
    url: api.expressCompanyOptions,
    method: 'get',
    params: parameter
  })
}


export function serviceApplyDo(parameter) {
  return axios({
    url: api.serviceApplyDo,
    method: 'post',
    data: parameter
  })
}


export function orderSend(parameter) {
  return axios({
    url: api.orderSend,
    method: 'post',
    data: parameter
  })
}


export function orderReceived(parameter) {
  return axios({
    url: api.orderReceived,
    method: 'post',
    data: parameter
  })
}

export function expressEdit(parameter) {
  return axios({
    url: api.expressEdit,
    method: 'post',
    data: parameter
  })
}

export function priceFix(parameter) {
  return axios({
    url: api.priceFix,
    method: 'post',
    data: parameter
  })
}

export function goodsRefund(parameter) {
  return axios({
    url: api.goodsRefund,
    method: 'post',
    data: parameter
  })
}

export function orderRecover(parameter) {
  return axios({
    url: api.orderRecover,
    method: 'post',
    data: parameter
  })
}

export function adminNoteEdit(parameter) {
  return axios({
    url: api.adminNoteEdit,
    method: 'post',
    data: parameter
  })
}

export function businessNoteEdit(parameter) {
  return axios({
    url: api.businessNoteEdit,
    method: 'post',
    data: parameter
  })
}

export function setOrderStar(parameter) {
  return axios({
    url: api.setOrderStar,
    method: 'post',
    data: parameter
  })
}

export function orderCancel(parameter) {
  return axios({
    url: api.orderCancel,
    method: 'post',
    data: parameter
  })
}

export function orderClose(parameter) {
  return axios({
    url: api.orderClose,
    method: 'post',
    data: parameter
  })
}

export function setAllStar(parameter) {
  return axios({
    url: api.setAllStar,
    method: 'post',
    data: parameter
  })
}


export function getOrderDownloadUrl(parameter) {
  return axios({
    url: api.getOrderDownloadUrl,
    method: 'post',
    data: parameter
  })
}
export function getFenxiaoOrderDownloadUrl(parameter) {
  return axios({
    url: api.fenxiaoOrderGoodsDownload,
    method: 'post',
    data: parameter
  })
}


export function expressImport(parameter) {
  return axios({
    url: api.expressImport,
    method: 'post',
    headers: {
      'Content-Type':'multipart/form-data'
    },
    data: parameter
  })
}



export function tuanComplete(parameter) {
  return axios({
    url: api.tuanComplete,
    method: 'post',
    data: parameter
  })
}
export function getBusinessOptions(parameter) {
  return axios({
    url: api.businessOptions,
    method: 'get',
    data: parameter
  })
}
export function getFenxiaoOrderList(parameter) {
  return axios({
    url: api.fenxiaoOrderList,
    method: 'get',
    params: parameter
  })
}

export function getExpressTrace(parameter) {
  return axios({
    url: api.expressTrace,
    method: 'get',
    params: parameter
  })
}




